export default "__VITE_ASSET__d78353b2__"